(() => {
  'use strict';

  function getConfig() {
    return window.MiniCartMoney || {};
  }

  function stripMoneyDecorations(str) {
    if (str == null) return '';
    let s = String(str);
    const cfg = getConfig();
    if (cfg.stripDecimals !== false) {
      s = s.replace(/\.00(?!\d)/g, '').replace(/\.00$/, '');
    }
    if (cfg.stripUsdSuffix) {
      s = s.replace(/\s*USD\s*$/i, '').trim();
    }
    return s;
  }

  function formatMoney(cents) {
    const value = Math.round(Number(cents) || 0);
    const cfg = getConfig();
    const format = cfg.moneyFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      try {
        let out = window.Shopify.formatMoney(value, format);
        out = stripMoneyDecorations(out);
        if (cfg.currency === 'SGD' && out.indexOf('S$') === -1 && out.indexOf('SGD') === -1) {
          out = out.replace(/^\$/, 'S$');
        }
        return out;
      } catch (_) {}
    }

    const currency = cfg.currency || 'USD';
    const noDecimals = cfg.stripDecimals !== false;
    const amount = noDecimals ? Math.round(value / 100) : value / 100;

    if (currency === 'SGD') {
      return 'S$' + amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    const symbol = cfg.symbol || '$';
    if (noDecimals) {
      return symbol + amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }
    return symbol + amount.toFixed(2);
  }

  function applyConfigFromCart(cart) {
    if (!cart) return;
    window.MiniCartMoney = window.MiniCartMoney || {};
    const pathSg = (window.location && window.location.pathname || '').indexOf('/en-sg') !== -1;
    if (cart.currency) {
      window.MiniCartMoney.currency = cart.currency;
    }
    if (cart.currency === 'SGD' || pathSg) {
      window.MiniCartMoney.currency = 'SGD';
      window.MiniCartMoney.moneyFormat = 'S${{amount}}';
      window.MiniCartMoney.symbol = 'S$';
      window.MiniCartMoney.country = 'SG';
    }
  }

  window.MiniCartFormatMoney = formatMoney;
  window.MiniCartApplyMoneyConfigFromCart = applyConfigFromCart;
})();
